module.exports = __webpack_public_path__ + "static/media/logo-ifp-simple.6597a9ec.svg";


//////////////////
// WEBPACK FOOTER
// ./src/features/Layout/assets/img/logo-ifp-simple.svg
// module id = 1905
// module chunks = 0